import { UntypedFormGroup, UntypedFormControl, UntypedFormArray, Validators } from '@angular/forms';

import { PcgTableColumn } from '../../../table/pcg-table-column.interface';

// tslint:disable:quotemark
// tslint:disable:max-line-length
// tslint:disable:whitespace
export class NixieUploadListVm {
	submittedDate: Date;
	nystaRecords: number;
	nysbaRecords: number;

	static get FormData() {
		return this.getFormData();
	}

	static getFormData(validators = {}) {
		return {
			'submittedDate': new UntypedFormControl('', [...(validators['submittedDate'] ?? []), ...[Validators.required]]),
			'nystaRecords': new UntypedFormControl(0, [...(validators['nystaRecords'] ?? []), ...[Validators.required]]),
			'nysbaRecords': new UntypedFormControl(0, [...(validators['nysbaRecords'] ?? []), ...[Validators.required]])
		};
	}

	static get Form() {
		return new UntypedFormGroup(this.FormData);
	}

	static get ColumnDefs(): Map<string, PcgTableColumn> {
		return new Map([
			['submittedDate', {"orderId":0,"sortColumn":"submittedDate","searchColumn":"submittedDate","includeInExcel":true,"exportColumn":null,"displayName":"Nixie File Submitted Date","isVisible":true,"canSearch":false,"isNdc":false,"multiSearchCellClasses":null}],
			['nystaRecords', {"orderId":1,"sortColumn":"nystaRecords","searchColumn":"nystaRecords","includeInExcel":true,"exportColumn":null,"displayName":"NYSTA Records","isVisible":true,"canSearch":false,"isNdc":false,"multiSearchCellClasses":null}],
			['nysbaRecords', {"orderId":2,"sortColumn":"nysbaRecords","searchColumn":"nysbaRecords","includeInExcel":true,"exportColumn":null,"displayName":"NYSBA Records","isVisible":true,"canSearch":false,"isNdc":false,"multiSearchCellClasses":null}]
		]);
	}

	static GetModel(fg: UntypedFormGroup): NixieUploadListVmFromFg {
		return new NixieUploadListVmFromFg(fg);
	}
}

export class NixieUploadListVmFromFg {
	constructor(public fg: UntypedFormGroup) { }


	get submittedDate(): Date {
		return this.fg.get('submittedDate').value;
	}
	set submittedDate(val) {
		this.fg.get('submittedDate').setValue(val);
	}

	get nystaRecords(): number {
		return this.fg.get('nystaRecords').value;
	}
	set nystaRecords(val) {
		this.fg.get('nystaRecords').setValue(val);
	}

	get nysbaRecords(): number {
		return this.fg.get('nysbaRecords').value;
	}
	set nysbaRecords(val) {
		this.fg.get('nysbaRecords').setValue(val);
	}
}
